import { ReactNode } from 'react'
import styled, { css } from 'styled-components'

import { theme } from '@/styles/theme'

type SectionTitleProps = {
  children: ReactNode
}

export const SectionTitle = ({ children }: SectionTitleProps) => {
  return (
    <>
      <SectionTitleDiv>
        <TitleDiv>{children}</TitleDiv>
      </SectionTitleDiv>
    </>
  )
}

const SectionTitleDiv = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  text-align: center;
  font-weight: bold;
  color: ${theme.colors.trialBlue};

  @media screen and (max-width: 1047px) {
    color: ${theme.colors.textTitle};
  }
`

const FontStyle = css`
  font-size: 26px;
  letter-spacing: 0;
`

const TitleDiv = styled.div`
  h2 {
    font-weight: bold;
    font-size: 40px;
    letter-spacing: 1.6px;
    line-height: 50px;

    span {
      font-size: 30px;
      letter-spacing: 1.2px;
    }
  }

  @media screen and (max-width: 1047px) {
    h2 {
      line-height: 37px;
      ${FontStyle}

      span {
        ${FontStyle}
      }
    }
  }
`
